export default __webpack_public_path__ + "static/media/laudo5.afb3f4b6.jpg";